import React from 'react';
import IError from './IError';
import InfoBox from '@appComponents/InfoBox/InfoBox';
import PlainCounter from '@appComponents/components/PlainCounter/PlainCounter';
import moment from 'moment';
import * as style from './ErrorStyle.module.scss'

const Error = ({ children, withRedirect }: IError) => {
  return (
    <div className={style.error}>
      <InfoBox error={true}>{children}</InfoBox>
      {withRedirect && (
        <div className={style.redirect}>
          You will be redirected to your BnkToTheFuture profile in:&nbsp;
          <PlainCounter
            timeLeft={moment().add(15, 'second').toString()}
            onComplete={() => (location.href = '/')}
            completedText={'0 sec'}
            abbreviated={true}            
          />
        </div>
      )}
    </div>
  );
};

export default Error;
